// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_g7-a";
export var fulfillmentFormRail = "_g7-9";
export var headerTitleRow = "_g7-c";
export var orderDetailsWrapper = "_g7-7";
export var orderLinkTrigger = "_g7-2";
export var paymentInformationGrid = "_g7-h";
export var paymentSummaryColumn = "_g7-i";
export var shipmentContainer = "_g7-b";
export var shipmentDetailsMainPane = "_g7-8";
export var shipmentNavigationCard = "_g7-5";
export var shipmentNavigationRail = "_g7-3";
export var shipmentNavigationRailHeader = "_g7-4";
export var shipmentSummaryFact = "_g7-e";
export var shipmentSummaryGrid = "_g7-d";
export var shipmentSummaryMetadataRow = "_g7-f";
export var shipmentSummaryTags = "_g7-g";
export var shipmentWorkspace = "_g7-0";
export var shipmentWorkspaceContent = "_g7-6";
export var shipmentWorkspaceHeader = "_g7-1";